<template>
    <el-dialog
        title="打印"
        :visible.sync="isShow"
        append-to-body
        :show-close="false"
        :close-on-click-modal="false"
        :close-on-press-escape="false"
        class="default-dialog acc-print-dialog"
    >
      <el-form ref="form" :model="form">
          <el-form-item label="账簿封面：">
            <el-radio-group v-model="form.isCover">
              <el-radio :label="true">
              <span style="position:relative;">
                <span>打印</span>
                <img src="../../../../static/img/default_img.png" alt="" class="default_img" @click="showCover = true">
              </span>
              </el-radio>
              <el-radio :label="false">不打印</el-radio>
            </el-radio-group>
          </el-form-item>
      </el-form>
      <div class="dialog-footer">
         <accBtn text="取消" type="2" @click="$emit('close')" />
         <accBtn text="开始打印" @click="$emit('print', form)" />
      </div>
       <!-- 查看封面 -->
       <el-dialog :visible.sync="showCover" width="900px" :close-on-click-modal="true" @close="showCover = false" custom-class="coverDialog" append-to-body>
        <img src="../../../../static/img/cover2.jpg" alt="" style="width:100%;">
      </el-dialog>
    </el-dialog>
  </template>
  <script>
  export default {
    props: {
      isShow:{
        type:Boolean,
        default: false
      },
    },
    components: {},
    data() {
      return {
        form: {
          isCover:false
        },
        showCover:false,
      }
    }
  }
  </script>
  <style lang="less" scoped>
  .acc-print-dialog {
    .dialog-footer {
      text-align: center;
      margin-top: 30px;
    }
  }

  .default_img{
    width: 14px;
    position: absolute;
    left: 32px;
    top: 3px;
    cursor: pointer;
  }
  </style>



// WEBPACK FOOTER //
// src/pages/accountBook/com/printCover.vue